import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { ModulesEnum, RaciTabs } from '../../../navigation/enum';
import { NavigationActionBase } from '../../../navigation/navigation-action-base';
import { NavigationService } from '../../../navigation/navigation.service';
import { RaciNavigationService } from '../../../navigation/raci-navigation.service';
import { UserDashboardService } from '../../user-dashboard/services/user-dahsboard.service';
import { ActionStageEnum } from '../models/enums/action-stage-enum';
import { TaskTypeEnum } from '../models/enums/task-type-enum';
import { RaciService } from '../services/raci.service';
import { EventBusService } from '../../../services/event-bus.service';
import { AppStorageService } from '../../../services/app-storage.service';

/**
 * Handles the RACI host component
 */
@Component({
  selector: 'raci-host',
  templateUrl: './raci-host.component.html',
  styleUrls: ['./raci-host.component.css', '../raci.css']
})
export class RaciHostComponent extends NavigationActionBase implements OnInit, OnDestroy {
  /**
 * The active checklist.
 */
  activeChecklist: any;

  /**
   * The steps in the checklist.
   */
  steps: Array<any> = [];

  /**
   * The project object.
   */
  project: any;

  /**
   * The portfolio object.
   */
  portfolio: any;

  /**
   * The active portfolio object.
   */
  activePortfolio: any;

  /**
   * Flag to control the display of parent-child view.
   */
  displayParentChildView = false;

  /**
   * Array of subscriptions.
   */
  private _subscriptions = new Array<Subscription>();

  /**
   * Array of valuation events.
   */
  valuationEvents: Array<any> = [];

  /**
   * Array that holds the parent-child relationship of valuation events.
   */
  parentChildValuationEvents: Array<{ "oid": number, "parent": any, "children": Array<any> }> = [];

  /**
   * Flag to control the display of RACI participants.
   */
  showRaciParticipants = false;

  /**
   * The active tab in the RACI view.
   */
  activeTab: RaciTabs;

  /**
   * Array of user projects.
   */
  userProjects: Array<any> = [];

  /**
   * The grouping option for displaying data.
   */
  groupBy: string;

  /**
   * The active step in the checklist.
   */
  activeStep: any;

  /**
   * The active task in the checklist.
   */
  activeTask: any;

  /**
   * The tasks related to approval.
   */
  approvalTasks: any;

  /**
   * The approval matrix of the task.
   */
  approvalMatrixOfTask: any;

  /**
   * The current user.
   */
  currentUser: any;

  /**
   * The active task in the user dashboard.
   */
  userDashboardActiveTask: any;

  /**
   * Flag to refresh the user tasks list.
   */
  refreshUserTasksList = false;

  /**
   * Flag to control the display of the confirm dialog.
   */
  showConfirmDialog = false;

  /**
   * Flag to hide the approval matrix.
   */
  hideApprovalMatrix = false;

  /**
   * Flag to control the display of approval history.
   */
  shouldShowApprovalHistory = false;

  /**
   * Flag to control the display of valuation events.
   */
  isValuationEventsDisplayed = true;

  /**
   * The approval matrix for general tasks.
   */
  generalTaskApprovalMatrix: any[];

  /**
   * Flag to control the display of publishing to Valorem.
   */
  isPublishToValoremDisplayed = false;

  /**
   * The tasks in the user dashboard.
   */
  userDashboardTasks: any;

  /**
   * The approval matrix of the function task.
   */
  approvalMatrixOfFunctionTask: any;

  /**
   * The tasks related to Valorem.
   */
  valoremTasks: any;

  /**
   * The tasks related to Argus.
   */
  argusTasks: any;

  /**
   * Flag to control whether the user can approve.
   */
  allowApproving = false;

  /**
   * The participants in the project.
   */
  projectParticipants: any;

  /**
   * Flag to control the display of the "Get Data from Argus" dialog.
   */
  showGetDataFromArgusDialog = false;

  /**
   * The properties associated with the project.
   */
  properties: any[];

  /**
   * Data for publishing to Valorem.
   */
  valoremPublishData: any;

  /**
   * Flag to control the display of syncing with Argus.
   */
  isSyncWithArgusDisplayed = false;

  /**
   * The selected report IDs.
   */
  selectedReportIds: any;

  /**
   * Information about the last sync with Argus.
   */
  argusLastSyncInfo: any;

  /**
   * The number of properties synced with Argus.
   */
  argusNumberOfSyncProp: any;

  /**
   * The ID of the project.
   */
  projectId: number;

  /**
   * Flag to control the display of task approval history.
   */
  shouldShowTaskApprovalHistory = false;

  /**
   * Flag to control the display of the "Close Valuation Event" dialog.
   */
  showCloseValuationEventDialog = false;

  /**
   * The message in the "Close Valuation Event" dialog.
   */
  closeValEventDialogMessage = "";

  /**
   * The option selected in the "Close Valuation Event" dialog.
   */
  closeValEventOptionSelected: number;

  /**
   * Flag to indicate whether the project is closed.
   */
  isProjectClosed = false;

  /**
   * Project steps
   */
  projectSteps: any;

  /**
   * Valuation event tasks
   */
  valuationEventTasks: any;

  /**
   * Copy properties?
   */
  copyProperties = false;

  /**
   * Copy the exchange rates?
   */
  copyFxTables = false;

  /**
   * New valuation date
   */
  newValuationDate: any;

  /**
   * New valuation event name
   */
  newValuationName: string;

  /**
   * Constructor
   * @param _navigationService
   * @param appStorage
   * @param eventBus
   * @param _ref
   * @param _raciService
   * @param _userDashboardService
   * @param _raciNavigationService
   * @param router
   */
  constructor(private _navigationService: NavigationService,
    appStorage: AppStorageService,
    eventBus: EventBusService,
    private _ref: ChangeDetectorRef,
    private _raciService: RaciService,
    private _userDashboardService: UserDashboardService,
    private _raciNavigationService: RaciNavigationService,
    private router: Router,

  ) {
    super(appStorage, eventBus, _ref, _navigationService)
  }

  /**
   *OnInit
   */
  ngOnInit(): void {
    this.setActiveModule();
    this.setSelectedProject();
    this._raciNavigationService.groupPortfolioProperties("");

    this._subscriptions.push(this.getData().subscribe(data => {
      if (data) {
        this.processPortfolioData(data[0]);
        this.processStepData(data[1]);
        this.projectSteps = data[1];
        this.setTasks(data[2]);
        this.projectParticipants = data[3];
        this.allowApproving = !!this.projectParticipants.find(participant => participant.userId == this.currentUser.OID);
        this._raciService.displayDataLoader(false);
      }
    }));

    this.onEvents.push(
      this.eventBus.subscribeEvent("raci:checkIfApprovalMatrixChanged", () => {
        this.eventBus.broadcastEvent("raci:shouldShowConfirmDialog", this.showConfirmDialog);
      })
    );

    this.subscriptions.add(this._raciNavigationService._hostResetShouldConfirmDialog.subscribe(resetValue => {
      this.showConfirmDialog = resetValue;
      this._raciNavigationService._onSaveApproval.next(false);
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._onDisplayApprovalHistory.subscribe(value => {
      this.shouldShowApprovalHistory = value;
    }));

    this.onEvents.push(this.eventBus.subscribeEvent("getDataFromArgusDialog", () => {
      this.properties = [];
      this.showGetDataFromArgusDialog = true;
    }));

    this.onEvents.push(this.eventBus.subscribeEvent("valuationEventsClicked", () => {
      this.isValuationEventsDisplayed = !this.isValuationEventsDisplayed;
    }));

    this.onEvents.push(this.eventBus.subscribeEvent("setActivePortfolioId", (value) => {
      this.activePortfolio = this.valuationEvents.find(portfolio => portfolio.oid == value);
    }));

    this.onDisplayPublishToValorem();
    this.onDisplayCloseValuationEventDialog();

    this.onRefreshTasks();
    this.subscribeToCloseEvent();
    this.subscribeToActiveTab();
    this.subscribeToDisplayParticipantsSection();
    this.subscribeToDisplayProjectSteps();
    this.groupPortfolioPropertiesBy();
    this.onDisplayTaskHistoryDialog();
    this.subscribeToIsProjectClosed();
    this._ref.markForCheck();
  }

  /**
   * Subscribe to close event
   */
  subscribeToCloseEvent() {
    this._subscriptions.push(this._raciNavigationService._onCloseRaci.subscribe(() => {
      sessionStorage.setItem('raciValuationEventId', this.activePortfolio?.oid);
      if (this.showConfirmDialog) {
        sessionStorage.setItem('raciValuationBack', '1');
        this._raciNavigationService.closeRaci(true);
      } else {
        this._raciNavigationService.closeRaci(false);
      }
    }));
  }

  /**
   * Subscribe to groupPortfolioProperties event
   */
  groupPortfolioPropertiesBy() {
    this._subscriptions.push(this._raciNavigationService._groupPortfolioProperties.subscribe(data => {
      this.groupBy = data;
    }))
  }

  /**
   * Gets the RaciTabs enum
   */
  public get raciTabs(): typeof RaciTabs {
    return RaciTabs;
  }

  /**
  * Gets the Action Stage enum
  */
  public get actionStage(): typeof ActionStageEnum {
    return ActionStageEnum;
  }

  /**
  * Gets the Task type enum
  */
  public get taskTypes(): typeof TaskTypeEnum {
    return TaskTypeEnum;
  }

  /**
   * OnDestroy
   */
  ngOnDestroy(): void {
    this._subscriptions.forEach(subscription => { subscription.unsubscribe() });
    this._raciNavigationService.setActivePortfolio(null);
  }

  /**
   * Set active checklist
   * @param value
   */
  setActiveChecklist(value: any): void {
    this.activeChecklist = value;
    this.displayParentChildView = true;
  }

  /**
   * Set active module
   */
  private setActiveModule() {
    this._navigationService.setActiveModule(ModulesEnum.Raci);
    this._navigationService.setActiveRaciTab(RaciTabs.Overview);
  }

  /**
   * Set selected project
   */
  private setSelectedProject() {
    this.portfolio = this.appStorage.getSelectedPortfolio();
    if (!this.portfolio) {
      this.router.navigate(['/pd']);
    } else {
      this.projectId = this.portfolio.ProjectID;
      this._raciNavigationService._projectId = this.projectId;
      this._raciNavigationService._portfolioId = this.portfolio.Oid;
      this.checkIfProjectIsClosed();
    }
  }

  /**
   * Get all data
   */
  private getData() {
    const projectSteps = this._raciService.getProjectSteps(this.projectId);
    const portfolios = this._raciService.getValuationEvents(this.projectId);
    this.currentUser = this.appStorage.getCurrentUserDetails();
    const approvalTasks = this._userDashboardService.getApprovalTasks(this.currentUser?.OID);
    const projectParticipants = this._raciService.getParticipants(false, null, this.projectId);

    return forkJoin([portfolios, projectSteps, approvalTasks, projectParticipants]);
  }

  /**
   * Add valuation child to portfolio
   * @param childValEvents List of childred events
   * @param portfolio Portfolio
   */
  private addChildValuationEventsToPortfolio(childValEvents: any[], portfolio: any) {
    if (childValEvents?.length == 0) {
      this.addPortfolioToParentChildEvents(portfolio, null);
    }
    else {
      childValEvents.forEach(childPortfolio => {
        this.addPortfolioToParentChildEvents(portfolio, childPortfolio);
      });
    }
  }

  /**
   * Add portfolio to parent child
   * @param portfolio Portfolio
   * @param childrenEvents Children event
   */
  addPortfolioToParentChildEvents(portfolio, childrenEvent) {
    if (this.getExistingParentEvent(portfolio) != null) {
      this.getExistingParentEvent(portfolio).children.push(this.createChildNode(childrenEvent));
    } else {
      this.parentChildValuationEvents.push({ oid: portfolio.oid, parent: this.createParentNode(portfolio), children: [] });
      if (childrenEvent) {
        this.getExistingParentEvent(portfolio).children.push(this.createChildNode(childrenEvent));
      }
    }
  }

  /**
   * Saves approval changes
   * @param approvalMatrix Approval matrix data
   */
  public saveApprovalChanges(approvalMatrix: Array<any>) {
    this._subscriptions.push(this._raciService.updateApprovalMatrix(approvalMatrix).subscribe(data => {
      if (data) {
        this.refreshUserTasks();
      }
    }));
  }

  /**
   * Sets should shouw confirmation dialog flag value
   * @param showDialog Indicator wheater or not the confirm dialog should be displayed
   */
  setShouldShowConfirmDialog(showDialog: boolean) {
    this.showConfirmDialog = showDialog;
  }

  /**
  * Sets active step
  * @param step Step data
  */
  public setActiveStep(step: any) {
    if (this.showConfirmDialog) {
      this.displayConfirmDialog();
    }
    else {
      this.activeStep = step;
      this.activeTask = this.activeStep?.tasks?.find(task => !task.isCompleted || task.taskActionStage === ActionStageEnum.Waiting);
   this.eventBus.broadcastEvent("isTaskInProgress", this.activeTask?.taskActionStage === ActionStageEnum.Waiting);
      if (this.activeTask && this.activeTask.projectId == null) {
        this.activeTask.projectId = this.projectId;
      }
    }

    this._raciNavigationService.onDisplayTaskApprovalHistoryDialog(false);
    this.resetNavigationAfterTaskStepChange();
    this.updateNavigationIcons(this.activeTask);
  }

  /**
   * Sets active task
   * @param task Task data
   */
  public setActiveTask(task: any) {
    if (this.showConfirmDialog) {
      this.displayConfirmDialog();
    }
    else {
      this.activeTask = task;
    }

    if (this.activeTask) {
      this.resetNavigationAfterTaskStepChange();
      this.updateNavigationIcons(this.activeTask);
    }
  }

  /**
   * Resets navigation after task/step change
   */
  private resetNavigationAfterTaskStepChange() {
    this._raciNavigationService.onDisplayTaskApprovalHistoryDialog(false);
  }

  /**
   * Update navigation icons
   * @param task Active task
   */
  updateNavigationIcons(task: any) {
    this._raciNavigationService.resetNavigationIcons();

    switch (task?.taskTypeId) {
      case this.taskTypes.ValuationEventFunction:
        this._raciNavigationService.setActiveValuationEventIcons(task);
        break;
      case this.taskTypes.CloseValuationEvent:
        //Hide all icons
        break;
      case this.taskTypes.ValuationEffectiveDatesSetup:
        this._raciNavigationService.setActiveValuationEffectiveDatesSetupIcons(task);
        break;
      case this.taskTypes.ValoremFunction:
        this._raciNavigationService.setActiveValoremIcons();
        break;
      case this.taskTypes.Approval:
        this._raciNavigationService.setActiveApprovalIcons(task);
        break;
      case this.taskTypes.ArgusFunction:
        this._raciNavigationService.setActiveArgusIcons();
        break;
      case this.taskTypes.ArgusSyncFunction:
        this._raciNavigationService.setActiveArgusSyncIcons();
        break;
      case this.taskTypes.Undefined:
        this._raciNavigationService.setActiveUndeFinedTaskIcons(task);
        break;
      default:
        break;
    }
  }

  /**
   * On display publish to valorem
   */
  onDisplayPublishToValorem(): void {
    this._subscriptions.push(this._raciNavigationService._onDisplayPublishToValorem.subscribe(value => {
      this.isPublishToValoremDisplayed = value;
    }))
  }

  /**
   * On refresh task action
   */
  onRefreshTasks() {
    this._subscriptions.push(this._raciNavigationService.refreshTasks.subscribe(data => {
      const activeTaskId = this.activeTask?.projectTaskId ?? this.activeTask?.taskId;
      const activeStepId = this.activeStep?.projectStepId;
      if (data) {
        this._raciService.displayDataLoader(true);
        this._subscriptions.push(this.getData().subscribe(data => {
          if (data) {
            this.processServiceData(data, activeTaskId, activeStepId);
          }
        }));
      }
    }));
  }

  /**
   * Processes service data
   * @param data Service data
   * @param activeTaskId active task id
   * @param activeStepId actove step id
   */
  private processServiceData(data: any, activeTaskId: number, activeStepId: number) {
    this.processPortfolioData(data[0]);
    this.processStepData(data[1]);
    this.projectSteps = data[1];
    this.setTasks(data[2]);
    this.projectParticipants = data[3];
    this.allowApproving = !!this.projectParticipants.find(participant => participant.userId == this.currentUser.OID);
    this._raciService.displayDataLoader(false);

    if (this.activeTab == this.raciTabs.Overview) {
      this.activeStep = this.steps?.find(s => s.projectStepId === activeStepId);
      this.activeTask = this.activeStep?.tasks?.find(task => task.projectTaskId === activeTaskId);
    }
    else {
      this.activeTask = this.approvalTasks.find(task => task.taskId == activeTaskId) ?? this.valoremTasks.find(task => task.projectTaskId == activeTaskId) ?? this.argusTasks.find(task => task.taskId == activeTaskId);
    }

    this.argusLastSyncInfo = this.activeTask.approvalMatrix.sort(p => p.lastDataSync)[this.activeTask.approvalMatrix.length - 1];
    this.argusNumberOfSyncProp = this.activeTask.approvalMatrix.filter(p => p.dataStatus !== 'NOT SYNCED').length;
    this._ref.markForCheck();
  }

  /**
   * Sets different types of tasks
   * @param data Tasks retrieved from the service
   */
  private setTasks(data: any) {
    this.approvalTasks = data.approvalTasks;
    this.valoremTasks = data.valoremTasks;
    this.argusTasks = data.argusTasks;
    this.valuationEventTasks = data.valuationEventTasks;
    this.userDashboardTasks = data;
  }

  /**
   * Set approval matrix for valorem tesks
   * @param data
   */
  setapprovalMatrixOfFunctionTask(data: any) {
    this.approvalMatrixOfFunctionTask = data;
    this.approvalMatrixOfTask = null;
    this.generalTaskApprovalMatrix = null;
  }

  /**
   * Sets active task for user dashboard
   * @param taskId Task Id
   */
  public setActiveUserTask(taskId) {
    this.activeTask = this.approvalTasks.find(task => task.taskId == taskId) ?? this.valoremTasks.find(task => task.projectTaskId == taskId) ?? this.argusTasks.find(task => task.taskId == taskId) ?? this.valuationEventTasks?.find(task => task.taskId == taskId);

    if (this.activeTask?.taskTypeId == null) {
      this.activeTask.taskTypeId = 1;
    }

    if (this.activeTask.projectId == null) {
      this.activeTask.projectId = this.projectId;
    }

    this.userDashboardActiveTask = taskId;
    this.hideApprovalMatrix = false;

    this.updateNavigationIcons(this.activeTask);
  }

  /**
   * Update status of user dashboard active task
   * @param status Task status
   */
  setUserDashboardCompleteTaskStatus() {
    this._subscriptions.push(this._userDashboardService.getApprovalTasks(this.currentUser?.OID).subscribe(data => {
      if (data) {
        const completedTask = this.approvalTasks.approvalTasks.find(x => x.taskId == this.userDashboardActiveTask);
        this.approvalTasks = data.approvalTasks;
        this.refreshUserTasksList = true;
        const unApprovedProperty = this.approvalTasks.filter(property => property.portfolioId == completedTask.taskValuationPortfolioId && (!property.dateApproved1 || !property.dateApproved2 || !property.dateApproved3) && property.taskId == completedTask.taskId)
        if (unApprovedProperty.length == 0) {
          this.hideApprovalMatrix = true;
        }
      }
    }));
  }

  /**
   * Set approval matrix
   * @param data Approval matrix data
   */
  setApprovalMatrix(data: any) {
    this.approvalMatrixOfTask = data;
    this.generalTaskApprovalMatrix = null;
    this.approvalMatrixOfFunctionTask = null;
  }

  /**
   * Set general task approval matrix
   * @param data Approval matrix data
   */
  setGeneralTaskApprovalMatrix(data: any) {
    this.generalTaskApprovalMatrix = data;
    this.approvalMatrixOfTask = null;
    this.approvalMatrixOfFunctionTask = null;
  }

  /**
   * Update task complete status and check step status
   * @param status Task status
   */
  updateCompleteTaskStatus(status: any) {
    this.completeTask(this.activeStep.tasks, this.activeTask);

    if (!this.activeStep?.tasks.find(task => { return !task.isCompleted; }) && !this.activeStep.relatedSteps.find(step => !step.isCompleted)) {

      this.steps?.forEach(stepItem => {
        if (stepItem.relatedSteps && stepItem.relatedSteps.length > 0) {
          stepItem.relatedSteps.forEach(relatedStep => {
            if (relatedStep.projectStepId == this.activeStep.projectStepId) {
              relatedStep.isCompleted = true;
              relatedStep.actionStageId = ActionStageEnum.Completed;
            }
          });
        }
      })

      this.activeStep.isCompleted = true;
      this.activeStep.actionStageId = ActionStageEnum.Completed;
    } else {
      this._raciService.updateStepActionStage(this.activeStep?.projectStepId).subscribe(data => {
        if (data) {
          this.activeStep.isCompleted = false;
          this.activeStep.actionStageId = ActionStageEnum.Waiting;
        }
      });
    }
  }

  /**
   * Process of completing task
   * @param tasks List of tasks
   * @param currentTask Current task
   */
  completeTask(tasks: any, currentTask: any) {
    let status = false;

    //go through all related tasks of each task and check if they have a current task
    tasks.forEach(task => {
      const pendingConfigTask = task.relatedTasks.find(relatedTask => relatedTask.projectTaskId == currentTask.projectTaskId && !relatedTask.isCompleted);
      if (pendingConfigTask) {
        status = true;
        pendingConfigTask.isCompleted = true;
      }
    });

    //go through all the tasks and check if they are completed, if they are, repeat the task completion process
    if (status) {
      tasks.forEach(task => {
        if (!task.approvalMatrix.find(approval => !approval.dateApproved1 || !approval.dateApproved2 || !approval.dateApproved3) && !task.relatedTasks.find(relatedTask => !relatedTask.isCompleted) && task.projectTaskId != currentTask.projectTaskId) {
          this.completeTask(tasks, task);
        }
      });
    }

    if (!currentTask.approvalMatrix.find(approval => !approval.dateApproved1 || !approval.dateApproved2 || !approval.dateApproved3) && !currentTask.relatedTasks.find(relatedTask => !relatedTask.isCompleted)) {
      currentTask.isCompleted = true;
      currentTask.taskActionStage = ActionStageEnum.Completed;
    } else {
      currentTask.isCompleted = false;
      currentTask.taskActionStage = ActionStageEnum.Waiting;
    }
  }

  /**
  * Sets active portfolio
  * @param selectedPortfolio Selected portfolio data
  */
  setActivePortfolio(selectedPortfolio: any) {
    this.activePortfolio = this.valuationEvents.find(portfolio => selectedPortfolio.oid == portfolio.oid);
    if (!this.activePortfolio) {
      const valEvent = this.valuationEvents.find(portfolio => { return portfolio.childValuationPortfolios.find(childEvent => { return childEvent.oid == selectedPortfolio.oid }) });
      this.activePortfolio = valEvent.childValuationPortfolios.find(valEvent => { return valEvent.oid == selectedPortfolio.oid })
    }
    this._raciNavigationService.setActivePortfolio(this.activePortfolio);
    const projectSteps = this.steps?.filter(step => step?.stepProjectId != null);
    this.steps = this.activePortfolio?.steps?.concat(projectSteps);
    this.steps?.sort((a, b) => (a.stepOrderNumber > b.stepOrderNumber ? 1 : -1));
    this.steps?.forEach(step => step.tasks?.sort((a, b) => (a.taskOrderNumber > b.taskOrderNumber ? 1 : -1)))
    this.setActivePortfolioStep();
  }

  /**
   * Update valuation event list
   * @param stepValuationPortfolioId Step portfolio id
   */
  updateValuationEventList(stepValuationPortfolioId: any) {
    const valuationEvent = this.valuationEvents.find(item => item.oid === stepValuationPortfolioId)
    const completedValuationEvent = !valuationEvent?.steps?.find(step => { return !step.isCompleted; });
    //delete valuation event from list if its completed
    if (completedValuationEvent) {
      this.removeCompletedValuationEvent(valuationEvent.oid);
      this.setActivePortfolio(stepValuationPortfolioId);
    }
  }

  /**
   * Set active step to completed
   * @param step Step
   */
  completeStep(step: any) {
    const stepValuationPortfolioId = step.stepValuationPortfolioId;
    this.updateStepCompletionInfo(step);
    this.steps?.forEach(stepItem => {
      if (stepItem.relatedSteps && stepItem.relatedSteps.length > 0) {
        stepItem.relatedSteps.forEach(relatedStep => {
          if (relatedStep.projectStepId == step.projectStepId) {
            this.updateStepCompletionInfo(relatedStep);
          }
        })
      }
    })

    this._subscriptions.push(this._raciService.completeStep(step).subscribe(data => {
      if (data) {
        step.actionStageId = ActionStageEnum.Completed;
        this.updateValuationEventList(stepValuationPortfolioId);
      }
    }));
  }

  /**
   * Completes function task
   * @param task Task that needs to be completed
   */
  completeFunctionTask(task: any) {
    task.isCompleted = true;
    task.taskDateModified = new Date();
    task.taskModifiedBy = this.currentUser?.OID;
    task.taskModifiedByUserName = this.currentUser?.User_Description;
    task.taskActionStage = ActionStageEnum.Completed;
    this._subscriptions.push(this._raciService.completeTask(task).subscribe(data => {
      if (data) {
        this.checkCompleteTaskStatus(task, this.activeStep);
        this._raciNavigationService.onSyncPortfolioWithArgus(false, 0);
        this._raciNavigationService.showSyncWithArgus(false);
        this._raciNavigationService.onSyncWithValorem(false);
      }
    }));
  }

  /**
   * Check if task is uncompleted
   * @param task Task
   */
  isTaskUncompleted(task: any) {
    return task.approvalMatrix.find(approval => approval.dateApproved1 || approval.dateApproved2 || approval.dateApproved3 || approval.dateRejected1 || approval.dateRejected2 || approval.dateRejected3);
  }

  /**
   * Check if task is completed
   * @param Task
   */
  isTaskCompleted(task: any) {
    return task.approvalMatrix && task.approvalMatrix.length !== 0 && !task.approvalMatrix.find(approval => !approval.dateApproved1 || !approval.dateApproved2 || !approval.dateApproved3);
  }

  /**
   * Check if step is uncompleted
   * @param step Step
   */
  isStepUncompleted(step: any) {
    return step?.tasks?.find(task => { return !task.isCompleted; }) || step.relatedSteps?.find(step => !step.isCompleted) || step.relatedSteps?.find(step => step.stepActionStage == ActionStageEnum.Waiting);
  }

  /**
   * Update approval matrix
   * @param approvalMatrix Approval Matrix
   */
  updateCurrentApprovalMatrix(approvalMatrix: any) {
    const valEvent = this.valuationEvents?.find(valEvent => { return valEvent.oid == approvalMatrix[0]?.portfolioId });
    const step = valEvent?.steps?.find(step => { return step.projectStepId == approvalMatrix[0]?.stepId });
    const task = step?.tasks?.find(task => { return task.projectTaskId == approvalMatrix[0]?.taskId });

    if (task) {
      task.approvalMatrix = approvalMatrix;
      this.checkCompleteTaskStatus(task, step);
    }
  }

  /**
   * Check status of task, step and valuation Event
   * @param task Task
   * @param step Step
   */
  checkCompleteTaskStatus(task, step) {
    if (task.taskTypeId == this.taskTypes.ValoremFunction || task.taskTypeId == this.taskTypes.ArgusFunction || task.taskTypeId == this.taskTypes.ArgusSyncFunction || this.taskTypes.ValuationEventFunction) {
      this.checkFunctionTaskStatus(task, step);
    } else {
      this.checkNonFunctionTaskStatus(task, step);
    }
  }

  /**
   * Check a function task's status
   * @param task
   * @param step
   * @returns
   */
  private checkFunctionTaskStatus(task, step) {
    const incompletedTask = step?.tasks?.find(task => { return !task.isCompleted });
    if (incompletedTask) { return; }
    this.updateStepCompletionInfo(step);
    this._raciService.completeStep(this.activeStep).subscribe(data => {
      if (data) {
        this.activeStep.actionStageId = ActionStageEnum.Completed;
      }
    });
  }

  /**
   * Checks a non-function task's status
   * @param task
   * @param step
   * @returns
   */
  private checkNonFunctionTaskStatus(task, step) {
    const incompletedTask = task?.approvalMatrix?.find(property => { return !property.dateApproved1 || !property.dateApproved2 || !property.dateApproved3 });
    if (incompletedTask) { return; }
    task.isCompleted = true;
    const incompletedStep = step?.tasks?.find(task => { return !task.isCompleted });
    if (incompletedStep) { return; }
    this.updateStepCompletionInfo(step);
    this._raciService.completeStep(this.activeStep).subscribe(data => {
      if (data) {
        this.activeStep.actionStageId = ActionStageEnum.Completed;
        this.updateValuationEventList(step.stepValuationPortfolioId);
      }
    });
  }

  /**
   * Update active task
   * @param task Task
   */
  updateActiveTask(task) {
    this.subscriptions.add(this._raciService.updateActiveTask(task).subscribe(data => {
      if (data) {
        this.displayConfirmDialog();
      }
    }));
  }

  /**
   * Check if approving is allowed
   */
  isApprovingAllowed() {
    this.allowApproving = !!this.projectParticipants.find(participant => participant.userId == this.currentUser.OID) && !this.activePortfolio.isFinalized;
    return this.allowApproving;
  }

  /**
   * Close all side panels
   */
  closeAllPanes() {
    this.showGetDataFromArgusDialog = false;
    this.isSyncWithArgusDisplayed = false;
    this._raciNavigationService.onUpdateSyncWithArgusActiveStatus(false);
  }

  /**
   * On valorem publish information change event
   * @param publishData Valorem publish data
   */
  onValoremPublishInformationChange(publishData: any) {
    if (publishData?.publishStatus) {
      this.activeTask.valoremPublishInformation = publishData;
    } else if (this.activeTask.valoremPublishInformation && publishData.lastSyncStatus) {
        this.activeTask.valoremPublishInformation.lastSyncStatus = publishData.lastSyncStatus;
    }
  }

  /**
   * Continue with second step of sync with Argus
   */
  continueWithArgus() {
    this.showGetDataFromArgusDialog = false;
    this.isSyncWithArgusDisplayed = true;
  }

  /**
   * Sync with Argus action
   * @param data Data
   */
  syncWithArgus(data: any) {
    this.selectedReportIds = data[0];
    this.properties = data[1];
    if (this.selectedReportIds.length < 1) {
      this._raciService.createReports(this.activePortfolio?.oid).subscribe(data => {
        if (data) {
          this.getReports(this.properties);
        }
      });
    }
    this.showGetDataFromArgusDialog = true;
  }

  /**
   * Get Reports of valuation event
   */
  getReports(properties: any) {
    const reportsIds = [];
    this._subscriptions.push(this._raciService.getReports(this.projectId, this.activePortfolio?.oid).subscribe(data => {
      if (data) {
        properties.forEach(property => {
          const item = data.find(report => report.PropertyId === property.propertyId);
          if (item) reportsIds.push(item.Oid);
        });
        this.selectedReportIds = reportsIds;
      }
    }));
  }

  /**
  * Listens for changes on displaying approval history
  */
  onDisplayTaskHistoryDialog() {
    this._subscriptions.push(this._raciNavigationService._onDisplayTaskApprovalHistoryDialog.subscribe(value => {
      this.shouldShowTaskApprovalHistory = value;
    }))
  }

  /**
   * Show close valuation event listener
   */
  onDisplayCloseValuationEventDialog(): void {
    this._subscriptions.push(this._raciNavigationService._showCloseValuationEventDialog.subscribe(value => {
      this.showCloseValuationEventDialog = value;
    }));
  }

  /**
   * On selected close option 
   * @param closeOption Selected close option
   */
  onSelectedCloseOption(closeOption: number) {
    switch (closeOption) {
      case 1:
        this.closeValEventDialogMessage = "raci.closeValuationEvent.closeFirstOptionDescription";
        this.closeValEventOptionSelected = 1;
        break;
      case 2:
        this.closeValEventDialogMessage = "raci.closeValuationEvent.closeSecondOptionDescription";
        this.closeValEventOptionSelected = 2;
        break;
      case 3:
        this.closeValEventDialogMessage = "raci.closeValuationEvent.closeThirdOptionDescription";
        this.closeValEventOptionSelected = 3;
        break;
      default:
        this.closeValEventDialogMessage = "";
        this.closeValEventOptionSelected = 0;
        break;
    }
  }

  /**
   * Subscribes to isProjectClosed event
   */
  subscribeToIsProjectClosed() {
    this._raciNavigationService._isProjectClosed.subscribe(value => {
      this.isProjectClosed = value;
    });
  }

  /**
   * Checks if project is closed
   */
  checkIfProjectIsClosed() {
    this._raciService.isProjectClosed(this.projectId).subscribe(data => {
      if (data.success) {
        this._raciNavigationService.setIsProjectClosed(true);
      }
    });
  }

  /**
  * Retrive existing parent event
  * @param parentEvent Parent event
  */
  private getExistingParentEvent(parentEvent): any {
    return this.parentChildValuationEvents.find(valEvent => { return valEvent.oid == this.createParentNode(parentEvent).oid })
  }

  /**
   * Create new parent node
   * @param parentNode Parent node
   */
  private createParentNode(parentNode: any): any {
    return {
      "oid": parentNode.oid,
      "name": parentNode.valuationPortfolioName
    };
  }

  /**
   * Create new child node
   * @param childNode Child node
   */
  private createChildNode(childNode: any): any {
    return {
      "oid": childNode?.oid,
      "name": childNode?.valuationPortfolioName
    }
  }

  /**
  * Subscribes to showProjectStepsEvent event
  */
  private subscribeToDisplayProjectSteps() {
    this._subscriptions.push(this._raciService._showProjectStepsEvent.subscribe(data => {
      this.displayParentChildView = !this.displayParentChildView;
    }));
  }

  /**
  * Subscribes to activeRaciTab$ event
  */
  private subscribeToActiveTab() {
    this._subscriptions.push(this._navigationService.activeRaciTab$.subscribe(activeTab => {
      this.activeTab = activeTab;
      this.userDashboardActiveTask = null;
      this.generalTaskApprovalMatrix = null;
      this.approvalMatrixOfFunctionTask = null;
      this.activeTask = null;
      this._raciNavigationService.resetNavigationIcons();

      if (activeTab == this.raciTabs.UserDashboard) {
        this._raciService.displayDataLoader(true);
        this.refreshData();
      }
    }));
  }

  /**
   * Subscribes to showRaciParticipantsSection event 
   */
  private subscribeToDisplayParticipantsSection() {
    this._raciNavigationService._showRaciParicipantsSection.subscribe(response => {
      this.showRaciParticipants = response;
    });
  }

  /**
   * * Process step data
   * @param data Steps
   */
  private processStepData(data: any) {
    this.steps = data;
    this.steps = this.steps?.concat(this.valuationEvents.find(ve => ve.oid == this.activePortfolio?.oid)?.steps);
    // Order steps by stepOrderNumber
    this.steps?.sort((a, b) => (a.stepOrderNumber > b.stepOrderNumber ? 1 : -1));
    // Order task bt raskOrderNumber
    this.steps?.forEach(step => step?.tasks?.sort((a, b) => (a.taskOrderNumber > b.taskOrderNumber ? 1 : -1)))
    this.setActivePortfolioStep();
  }

  /**
   * Sets active step and task for active portfolio
   */
  private setActivePortfolioStep() {
    this.steps?.forEach(step => {
      step?.tasks?.forEach(task => {
        if (this.isTaskCompleted(task)) {
          task.isCompleted = true;
          task.taskActionStage = ActionStageEnum.Completed;
        } else if (this.isTaskUncompleted(task)) {
          task.isCompleted = false;
          task.taskActionStage = ActionStageEnum.Waiting;

        }
      })
      if (step?.isCompleted) {
        if (this.isStepUncompleted(step)) {
          step.isCompleted = false;
          step.actionStageId = ActionStageEnum.Waiting;
        }
      }
    })

    // Set active step and task 
    this.activeStep = this.steps?.find(step => !step?.isCompleted);
    this.activeTask = this.activeStep?.tasks?.find(task => !task?.isCompleted);
    this.eventBus.broadcastEvent("isTaskInProgress", this.activeTask?.taskActionStage === ActionStageEnum.Waiting);
  }

  /**
   * On close project
   */
  onCloseProject() {
    this.valuationEvents?.forEach(valEvent => {
      valEvent.steps?.forEach(step => {
        step.tasks?.forEach(task => {
          this.markTaskAsCompleted(task);
        });
        this.markStepAsCompleted(step);
      });

      this.completeApprovalTasks(valEvent);
      this.completeArgusTasks(valEvent);
      this.completeValoremTasks(valEvent);
      this.completeValuationEventTasks(valEvent);
      this.refreshUserTasksList = true;
    });

    this.completeProjectSteps();
    this._raciNavigationService.showCloseValuationEventDialog(false);
    this._raciService.displayDataLoader(false);
  }

  /**
   * Process portfoilo data
   * @param data Portfolios
   */
  private processPortfolioData(data: any) {
    this.valuationEvents = Array.isArray(data) ? data : [data];
    this.parentChildValuationEvents = [];
    // Take selected portfolio as reference
    this.activePortfolio = this.valuationEvents.find(event => event.oid == this.portfolio?.Oid);
    this._raciNavigationService.setActivePortfolio(this.activePortfolio);
    this.processStepData(this.activePortfolio?.steps);

    this.valuationEvents.forEach(valEvent => {
      this.addChildValuationEventsToPortfolio(valEvent.childValuationPortfolios, valEvent);
    });
  }

  /**
   * Refresh user tasks after approval matrix is updated
   */
  private refreshUserTasks() {
    this._subscriptions.push(this._userDashboardService.getApprovalTasks(this.currentUser?.OID).subscribe(data => {
      if (data) {
        this.approvalTasks = data.approvalTasks;
        this.refreshUserTasksList = true;
      }
    }));
  }

  /**
   * Displays confirmation dialog
   */
  private displayConfirmDialog() {
    this.eventBus.broadcastEvent("openConfirmDialog", {
      success: () => {
        //Nothing
      }
    }, 'saveApproval');
  }

  /**
   * Removes the completed valuation event from the valuation event list.
   * @param id Valuation event id
   */
  private removeCompletedValuationEvent(id: number) {
    for (const event of this.valuationEvents) {
      if (event.oid === id) {
        this.valuationEvents.splice(this.valuationEvents.indexOf(event), 1);
        break;
      }
    }
    // remove child valuation event
    for (const parentChildItem of this.parentChildValuationEvents) {
      if (parentChildItem.oid == id) {
        this.parentChildValuationEvents.splice(this.parentChildValuationEvents.indexOf(parentChildItem), 1);
      }
    }
  }

  /**
 * Update step completion information
 * @param step Step that will be completed
 */
  private updateStepCompletionInfo(step: any) {
    step.isCompleted = true;
    step.stepDateModified = new Date();
    step.stepModifiedBy = this.currentUser?.OID;
    step.stepModifiedByUserName = this.currentUser?.User_Description;
  }

  /**
   * Marks task as completed
   * @param task Task that needs to be completed
   */
  private markTaskAsCompleted(task: any) {
    task.isCompleted = true;
    task.taskActionStage = this.actionStage.Completed;
    this._raciService.completeTask(task).subscribe();
  }

  /**
   * Marks step as completed
   * @param step Step that needs to be completed
   */
  private markStepAsCompleted(step: any) {
    step.isCompleted = true;
    step.actionStageId = this.actionStage.Completed;
    this._raciService.completeStep(step).subscribe();
  }

  /**
   * Completes all approval tasks before closing the valuation event
   * @param valEvent valuation event that will be closed
   */
  private completeApprovalTasks(valEvent: any) {
    this.userDashboardTasks?.approvalTasks?.filter(task => task.portfolioId == valEvent.oid).forEach(task => {
      task.taskActionStage = this.actionStage.Completed;
    });
  }

  /**
  * Completes all argus tasks before closing the valuation event
  * @param valEvent valuation event that will be closed
  */
  private completeArgusTasks(valEvent: any) {
    this.userDashboardTasks?.argusTasks?.filter(task => task.portfolioId == valEvent.oid).forEach(task => {
      task.taskActionStage = this.actionStage.Completed;
    });
  }

  /**
  * Completes all valorem tasks before closing the valuation event
  * @param valEvent valuation event that will be closed
  */
  private completeValoremTasks(valEvent: any) {
    this.userDashboardTasks?.valoremTasks?.filter(task => task.taskValuationPortfolioId == valEvent.oid).forEach(task => {
      task.taskActionStage = this.actionStage.Completed;
    });
  }

  /**
  * Completes all valuation event tasks before closing the valuation event
  * @param valEvent valuation event that will be closed
  */
  private completeValuationEventTasks(valEvent: any) {
    this.userDashboardTasks?.valuationEventTasks?.filter(task => task.portfolioId == valEvent.oid).forEach(task => {
      task.taskActionStage = this.actionStage.Completed;
    });
  }

  /**
   * Sets project steps to completed
   */
  private completeProjectSteps() {
    this.projectSteps?.forEach(step => {
      step.isCompleted = true;
      step.actionStageId = this.actionStage.Completed;
      this._raciService.completeStep(step).subscribe();
    })
  }

  /**
   * On select copy properties option
   */
  onSelectedCopyPropertiesOption(value: any) {
    this.copyProperties = value;
  }

  /**
   * On select copy fx tables option
   */
  onSelectedFxTablesOption(value: any) {
    this.copyFxTables = value;
  }

  /**
   * New valuation event date
   */
  onNewValuationDate(value: any) {
    this.newValuationDate = value;
  }

  /**
   * New valuation event name
   */
  onNewValuationName(value: any) {
    this.newValuationName = value;
  }

  /**
   * On create new valuation event
   */
  onCreateValuationEvent() {
    this._raciService.displayDataLoader(true);
    this.refreshData();
  }

  /**
   * Refresh with latest valuation event data
   */
  refreshData() {
    this._subscriptions.push(this.getData().subscribe(data => {
      if (data) {
        this.processPortfolioData(data[0]);
        this.processStepData(data[1]);
        this.projectSteps = data[1];
        this.approvalTasks = data[2].approvalTasks;
        this.valoremTasks = data[2].valoremTasks;
        this.argusTasks = data[2].argusTasks;
        this.valuationEventTasks = data[2].valuationEventTasks;
        this.userDashboardTasks = data[2];
        this.projectParticipants = data[3];
        this.allowApproving = !!this.projectParticipants.find(participant => participant.userId == this.currentUser.OID);
        this._raciService.displayDataLoader(false);
      }
    }));
  }
}
